import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { COMPANY } from "@/lib/config";

export default function MentionsLegales() {
    return (
        <main className="bg-cream text-ink min-h-screen" data-testid="mentions-legales-page">
            <header className="border-b border-border bg-cream/90 backdrop-blur">
                <div className="max-w-4xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
                    <Link to="/" data-testid="legal-back-home" className="inline-flex items-center gap-2 text-sm text-stone2 hover:text-brand">
                        <ArrowLeft size={16} /> Retour au site
                    </Link>
                    <span className="font-heading text-base font-semibold tracking-tight">{COMPANY.name}</span>
                </div>
            </header>
            <article className="max-w-3xl mx-auto px-6 md:px-10 py-16 md:py-24">
                <span className="label-overline text-brand">Informations légales</span>
                <h1 className="mt-4 font-heading text-4xl md:text-5xl font-light tracking-tighter text-ink leading-tight">
                    Mentions légales
                </h1>
                <p className="mt-4 text-sm text-stone2">
                    Dernière mise à jour : {new Date().toLocaleDateString("fr-FR", { year: "numeric", month: "long" })}
                </p>

                <div className="mt-12 space-y-10 text-base leading-relaxed text-ink/90">
                    <Section title="Éditeur du site">
                        <p><strong>{COMPANY.name}</strong></p>
                        <p>Activité : diagnostiqueur du bâti ancien et artisan en restauration (matériaux biosourcés)</p>
                        <p>Adresse : {COMPANY.address}</p>
                        <p>Téléphone : <a href={`tel:${COMPANY.phoneRaw}`} className="text-brand hover:underline">{COMPANY.phone}</a></p>
                        <p>Email : <a href={`mailto:${COMPANY.email}`} className="text-brand hover:underline break-all">{COMPANY.email}</a></p>
                        <p>N° SIRET / TVA intracommunautaire : <strong>FR43 404 536 732</strong></p>
                    </Section>

                    <Section title="Assurances professionnelles">
                        <p>
                            Responsabilité civile professionnelle (RC pro) et garantie décennale souscrites auprès de :
                        </p>
                        <p>
                            <strong>Abeille Assurances</strong> — Agence de Nonancourt<br />
                            Numéro de contrat : <strong>77881401</strong>
                        </p>
                        <p className="text-stone2 text-sm">
                            Couverture géographique : France métropolitaine.
                        </p>
                    </Section>

                    <Section title="Directeur de la publication">
                        <p>Le responsable de la publication est le représentant légal de l'{COMPANY.name}.</p>
                    </Section>

                    <Section title="Hébergement">
                        <p>
                            Ce site est hébergé sur la plateforme Emergent (Emergent Labs).
                            Les données sont stockées sur des serveurs sécurisés.
                        </p>
                    </Section>

                    <Section title="Propriété intellectuelle">
                        <p>
                            L'ensemble des contenus présents sur ce site (textes, images, logos, iconographies,
                            mises en page, structure) est la propriété exclusive de l'{COMPANY.name}, sauf
                            mentions contraires. Toute reproduction, représentation, modification, publication
                            ou adaptation, totale ou partielle, par quelque procédé que ce soit, est interdite
                            sans l'autorisation préalable écrite de l'éditeur.
                        </p>
                        <p className="text-stone2 text-sm mt-3">
                            Crédits photos : Unsplash (images d'illustration).
                        </p>
                    </Section>

                    <Section title="Limitation de responsabilité">
                        <p>
                            Les informations diffusées sur ce site sont présentées à titre indicatif et ne
                            sauraient engager la responsabilité de l'{COMPANY.name}. Les diagnostics, devis et
                            préconisations chiffrées font l'objet d'un document écrit personnalisé après
                            visite du bien concerné.
                        </p>
                    </Section>

                    <Section title="Liens hypertextes">
                        <p>
                            Le site peut contenir des liens vers des sites tiers. L'{COMPANY.name} n'exerce
                            aucun contrôle sur ces sites et ne saurait être tenu pour responsable de leur contenu.
                        </p>
                    </Section>

                    <Section title="Droit applicable">
                        <p>
                            Le présent site est soumis au droit français. En cas de litige, les tribunaux français seront seuls compétents.
                        </p>
                    </Section>
                </div>
            </article>
        </main>
    );
}

function Section({ title, children }) {
    return (
        <section>
            <h2 className="font-heading text-2xl font-medium tracking-tight text-ink mb-4">{title}</h2>
            <div className="space-y-3">{children}</div>
        </section>
    );
}
